<template>
  <div class="d-none">
      <input
        v-for="referenceEntry in transformedReference"
        :key="referenceEntry.name"
        type="hidden"
        :name="referenceEntry.name"
        :value="referenceEntry.value"
      />
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'AdvReactiveFormInputManipulator',
  props: {
    stateGetterReference: {
      type: String,
      required: true
    }
  },
  computed: {
    transformedReference () {
      let transformedReferenceData = _.get(this.$store.getters, this.stateGetterReference)
      if (_.isUndefined(transformedReferenceData)) {
        throw new Error(`Unable to find getter "${this.fetchedGetter}"`)
      }
      if (_.isFunction(transformedReferenceData)) {
        transformedReferenceData = transformedReferenceData()
      }
      return transformedReferenceData
    }
  }
}
</script>
